<template>
  <div>
    <list row-key="id" ref="list" unit="售后订单" :page="page" :query-params="params" :show-query="showQuery"
      :get-data-func="getDataFunc" max-height="600px">
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="订单编号" label-width="105px">
          <el-input v-model="params.orderSn" placeholder="请输入订单编号" clearable />
        </el-form-item>
        <el-form-item label="售后申请时间" label-width="105px">
          <range-picker :date="[params.refundStartDate, params.refundEndDate]"
            @change="x => { params.refundStartDate = x.Start; params.refundEndDate = x.End; }" />
        </el-form-item>
        <el-form-item label="订单状态" label-width="105px">
          <el-select v-model="params.orderStatus" placeholder="请选择" clearable>
            <el-option label="待付款" :value="0"></el-option>
            <el-option label="已付款" :value="1"></el-option>
            <el-option label="已发货" :value="2"></el-option>
            <el-option label="已签收" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="售后状态" label-width="105px">
          <el-select v-model="params.refundStatus" placeholder="请选择" clearable>
            <el-option label="退款关闭" value="退款关闭"></el-option>
            <el-option label="退款成功" value="退款成功"></el-option>
            <el-option label="商家驳回退款，待买家处理" value="商家驳回退款，待买家处理"></el-option>
            <el-option label="买家申请退款，待商家处理" value="买家申请退款，待商家处理"></el-option>
            <el-option label="买家申请退货，待商家处理" value="买家申请退货，待商家处理"></el-option>
            <el-option label="平台处理中" value="平台处理中"></el-option>
            <el-option label="已同意退货退款,待用户发货" value="已同意退货退款,待用户发货"></el-option>
            <el-option label="已寄回商品，待商家处理" value="已寄回商品，待商家处理"></el-option>
            <!-- <el-option label="无售后" value="无售后"></el-option> -->
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="mallMallId" label="店铺Id" min-width="150px" />
        <el-table-column prop="mallName" label="店铺名称" min-width="150px" />
        <el-table-column prop="orderSn" label="订单编号" min-width="180px" />
        <el-table-column prop="refundSn" label="售后Id" min-width="200px" />
        <el-table-column prop="goodsId" label="商品Id" min-width="200px" />
        <el-table-column prop="afterSalesStatus" label="售后状态" min-width="180px">
          <template slot-scope="{row}">
            <span>{{ row.afterSalesStatus }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="orderStatus" label="订单状态" min-width="150px">
          <template slot-scope="{row}">
            <span v-if="row.orderStatus == 0">待付款</span>
            <span v-if="row.orderStatus == 1">已付款</span>
            <span v-if="row.orderStatus == 2">已发货</span>
            <span v-if="row.orderStatus == 3">已签收</span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="refundReasonStr" label="售后原因" min-width="300px" /> -->
        <el-table-column prop="refundQuestion" label="售后问题" min-width="300px" />
        <el-table-column prop="afterSalesCreateTime" label="售后创建时间" min-width="160px" />
        <el-table-column prop="afterSalesExpireTime" label="售后逾期时间" min-width="160px" />
        <el-table-column prop="refundFree" label="退款金额" min-width="100px" />
        <el-table-column prop="refundExpressName" label="售后物流名称" min-width="180px" />
        <el-table-column prop="refundExpressNumber" label="售后物流单号" min-width="180px" />
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require('@/api/ks/order').default,
      params: {
        orderSn: "", // 订单编号
        refundStartDate: null, // 下单时间
        refundEndDate: null,
        orderStatus: null, // 订单状态
        refundStatus: null, // 售后状态
        isRefund: true, // 是否售后订单
      },
    };
  },
  created() { },
  methods: {
    getDataFunc(params) {
      params = this.$commonJs.obj.removeNullKey(params);
      return new Promise((resolve, reject) => {
        console.log("获取数据", params);
        this.api.getOrders(params).then(res => {
          console.log("getDataFunc", res);
          resolve({ code: 0, data: res.data, count: res.count, msg: null });
        }).catch(err => {
          reject(err);
        })
      })
    },
  },
};
</script>